import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var EmailShareIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm5,13a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V11.55l4.63,2.6a.71.71,0,0,0,.37.1.75.75,0,0,0,.38-.1L17,11.48Zm0-5.25-5,2.89L7,9.83V9A1,1,0,0,1,8,8h8a1,1,0,0,1,1,1Z"
}), 'EmailShareIcon');